// Keep in sync with backend/src/utils/publicEmailDomains.js (server is authoritative).
/**
 * Consumer / free mailbox providers. User accounts must use a corporate address, so these are rejected.
 * Blocklist (not allowlist) so it works for every tenant without per-tenant setup.
 */
const PUBLIC_EMAIL_DOMAINS = new Set([
  // Google / Microsoft / Yahoo / Apple / AOL
  'gmail.com', 'googlemail.com',
  'outlook.com', 'hotmail.com', 'live.com', 'msn.com', 'passport.com', 'windowslive.com',
  'hotmail.co.uk', 'hotmail.com.au', 'outlook.com.au', 'live.com.au', 'live.co.uk', 'outlook.co.uk',
  'yahoo.com', 'yahoo.com.au', 'yahoo.co.uk', 'yahoo.co.in', 'yahoo.in', 'yahoo.ca', 'yahoo.fr', 'yahoo.de',
  'ymail.com', 'rocketmail.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com', 'aim.com',
  // Privacy / other free providers
  'proton.me', 'protonmail.com', 'pm.me', 'tutanota.com', 'tutanota.de', 'tuta.io',
  'zoho.com', 'zohomail.com', 'mail.com', 'email.com', 'gmx.com', 'gmx.net', 'gmx.de', 'web.de',
  'yandex.com', 'yandex.ru', 'mail.ru', 'inbox.com', 'fastmail.com', 'fastmail.fm', 'hushmail.com',
  'rediffmail.com', 'qq.com', '163.com', '126.com', 'sina.com',
  // Australian ISP mailboxes
  'bigpond.com', 'bigpond.net.au', 'optusnet.com.au', 'iinet.net.au', 'internode.on.net', 'tpg.com.au',
  'westnet.com.au', 'dodo.com.au', 'ozemail.com.au', 'telstra.com',
])

function emailDomain(email) {
  const s = String(email || '').trim().toLowerCase()
  const at = s.lastIndexOf('@')
  return at > 0 ? s.slice(at + 1) : ''
}

function isPublicEmailDomain(email) {
  return PUBLIC_EMAIL_DOMAINS.has(emailDomain(email))
}

const PUBLIC_EMAIL_ERROR = 'Public email addresses (for example Gmail or Outlook) are not allowed. Use a corporate email address.'

export { PUBLIC_EMAIL_DOMAINS, emailDomain, isPublicEmailDomain, PUBLIC_EMAIL_ERROR }
